import Image from "next/image";
import style from "./EntryBlock.module.scss";
import MainBlob from "../../../animate/MainBlob";
import CoinsIcon from "../../../../public/workspace/coins_stack.svg";
import { useStore } from "../../../../stores/use_global_state";
import { addToLocalStorage } from "../../../../utils/nonAuthLocalStorage";
import { useState } from "react";
import AuthModal from "../../../AuthModal/AuthModal";

function EntryBlock({ dictionary, uploadFile = () => {} }) {
	// const [showAuthModal, setShowAuthModal] = useState(false)
	const { state } = useStore();

	const nonAuthHandler = () => {
		// if (state.isAuth) {
		//     return
		// }
		// addToLocalStorage("editor");
		// setShowAuthModal(true)
	};

	const title = dictionary["page_editor_h1"] || "AI Photo editor";
	const description = dictionary["page_editor_desc"] || "Enhance photo with our AI-powered editor online";

	return (
		<section className={style.section}>
			<div className={style.info}>
				<h1 className={style.title}>{title}</h1>
				<p className={style.description}>{description}</p>
				<label
					className={style.label}
					htmlFor="video_file"
					// onClick={nonAuthHandler}
				>
					<input
						// disabled={!state.isAuth}
						className={style.input}
						onChange={(event) => uploadFile(event.target.files)}
						type="file"
						name=""
						id="video_file"
						accept={`.mp4,.mov, .mkv, video/mp4, .webm, .jpg, .jpeg, .png, image/png, image/jpeg`}
						poster="/video/remove_bg_preview.png"
					/>
					{dictionary["Upload file"]}
				</label>
			</div>
			<Image className={style.image} src={"/image_editor/landing/entry.png"} width={812} height={660} alt="Image editor preview" />
			<MainBlob />
		</section>
	);
}

export default EntryBlock;
